import { containerPaddingRem } from '@exploration/shared-components';
import { desktop, tablet } from '@thrivent/midwest-shared';
import { MDSText } from '@thrivent/midwest-web';
import Image from 'next/image';
import styled from 'styled-components';

export const HeroStyles = {
  Title: styled(MDSText.HeroLg)`
    margin: 2rem 1rem 0;

    ${({ forceMobileBreakpoint }) =>
      !forceMobileBreakpoint &&
      `
      ${tablet} {
        margin: 3rem 0 1rem 0;
      }

      ${desktop} {
        margin: 3rem 0;
      }
    `}
  `,

  ImageContainer: styled.div<{
    forceMobileBreakpoint?: boolean;
  }>`
    position: relative;
    margin-top: 1rem;
    background: ${(p) => p.theme.midwestColors.neutralLightStrong};
    aspect-ratio: 1.5 / 1;
    margin-inline: -${containerPaddingRem};
    @supports not (aspect-ratio: 1.5 / 1) {
      height: 16.75rem;
    }

    ${({ forceMobileBreakpoint }) =>
      !forceMobileBreakpoint &&
      `
      ${tablet} {
        margin: 0;
        margin-right: -1rem;
        flex-grow: 0.5;
        aspect-ratio: unset;
      }

      ${desktop} {
        height: 22rem;
        margin-inline: 0;
      }
    `}
  `,

  Image: styled(Image)`
    object-fit: cover;
    height: 100%;
    width: 100%;
  `,
};
